import {
    Body,
    Box,
    Vec3
} from "cannon-es"
import {
    AnimationMixer
} from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader"
import { geometryToShape } from "../components/three-conversion-utils"

import { gsap } from "gsap"

import * as mat from "../components/materials"

import { defPath } from "../config/defPath"
import { PopsController } from "./popsController"


// ------------------------------------------------------------


export class Estadio {

    #_loader = new GLTFLoader()
    #_draco = new DRACOLoader()

    #_gltf
    #_mixer

    #_doors = {}
    #_doorsTimeline
    #_doorState = 0

    #_texts = []

    constructor(params) {
        // this.#_params = params
    }

    loadEstadio(name) {
        const loadControl = window.loadControl

        this.#_draco.setDecoderPath(`${defPath}/assets/glb/draco/`)
        this.#_draco.setDecoderConfig({ type: 'js' })

        this.#_gltf = new Promise( resolve => {
            this.#_loader
            .setDRACOLoader(this.#_draco)
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    resolve(gltf)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })
    }

    _createBody(obj) {
        let body = new Body({
            // mass: 0,
            shape: geometryToShape(obj.geometry),
        })
        body.position.copy(obj.position)
        body.quaternion.copy(obj.quaternion)

        // body.addEventListener('collide', (e) => {
        //     // window.soundController.play('collectable', false)
        // })

        if(window.world) window.world.addBody( body )

        obj.visible = false

        return body
    }

    _redirect(name) {
        
        if (window.popRedirect) return
        window.popRedirect = true
        // console.log(name)

        window.soundController.play('sections', false, 0.75)

        new PopsController().open("redirect", name.toLowerCase() )
    }

    _animarPuertas() {

        const t = this.#_doorsTimeline

        if(this.#_doorState == 0) {
            this.#_doorState = 1
            t.play()
        } else {
            this.#_doorState = 0
            t.reverse()
        }
        
    }

    async create() {

        // console.log('11', new Date().toISOString())

        const gltf = await this.#_gltf
        const scene = gltf.scene

        // console.log('12', new Date().toISOString())

        scene.traverse( obj => {

            if(obj.name == 'Cupula_01') obj.material = mat.glass_mat
            if (obj.name == 'Capra_lona_01') obj.material.map.anisotropy = 16

            // Botella
            if(obj.name.includes('Botella_cuerpo')) obj.material = mat.botella_mat
            if(obj.name.includes('Botella_etiqueta')) obj.material = mat.etiqueta_mat
            if(obj.name.includes('Botella_tapa')) obj.material = mat.tapa_mat

            // Lata
            if(obj.name.includes('Regular_body')) obj.material = mat.lata_mat

            // Publicidad
            if( obj.name.includes('PubVallas_') || obj.name.includes('PubCancha_') ) obj.material = mat.pub_mat

            // Puertas
            if(obj.name == 'Puerta_L') this.#_doors.left = obj
            if(obj.name == 'Puerta_R') this.#_doors.right = obj

            // Testos
            if(obj.name.includes('TextoStands_')) this.#_texts.push(obj)

            obj.castShadow = true
            obj.receiveShadow = true

            obj.material ? obj.material.envMapIntensity = 0.75 : undefined


            if(obj.name.includes('__grp')) obj.traverse( obj => obj.frustumCulled = false )

        // Cannon-es --------------

            if(obj.name.includes('L__')) this._createBody(obj)

            if(obj.name.includes('T__')) {
                const [a,name] = obj.name.split('__')
                const b = this._createBody(obj)
                b.addEventListener('collide', (e) => this._redirect(name) )
            }
            window.popRedirect = false

            // Puertas trigger
            if(obj.name == 'Trigger__PuertaCamerino') {
                const c = this._createBody(obj)
                c.isTrigger = true
                c.addEventListener('collide', (e) => this._animarPuertas() )
            }
        })

        this.#_mixer = new AnimationMixer(scene)
        const [clip] = gltf.animations
        if(clip) {
            const action = this.#_mixer.clipAction(clip)
            action.play()
        }

        window.scene.add(scene)


        // Define doors timeline
        const t = this.#_doorsTimeline = gsap.timeline({
            defaults: { duration: 1.5, ease: 'power1.out' },
            paused: true
        })
        t.fromTo( this.#_doors.right.rotation,
            { y: 0 }, { y: (-Math.PI / 2) + 0.15 }, 0)
        t.fromTo( this.#_doors.left.rotation,
            { y: 0 }, { y: (Math.PI / 2) - 0.15 }, 0.3)

    }

    update(delta) {
        if(this.#_mixer) this.#_mixer.update(delta)
        this.#_texts.forEach( n => n.lookAt( window.cameraController.camera.position ))
    }
}